<template>
  <div>
    <div class="m-subheader">
      <div class="mr-subheader-box">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <span class="subheader-icon">
              <i class="m-menu__link-icon flaticon-line-graph"></i>
            </span>
            <h3 class="m-subheader__title">Masraf Merkezi</h3>
          </div>
          <div>
            <div
              class="m-dropdown m-dropdown--inline m-dropdown--arrow m-dropdown--align-right m-dropdown--align-push"
              m-dropdown-toggle="hover"
              aria-expanded="true"
            >
              <a
                href="#"
                class="m-portlet__nav-link btn btn-lg btn-secondary m-btn m-btn--outline-2x m-btn--air m-btn--icon m-btn--icon-only m-btn--pill m-dropdown__toggle"
              >
                <i class="la la-plus m--hide"></i>
                <i class="la la-ellipsis-h"></i>
              </a>
              <div class="m-dropdown__wrapper" style="z-index: 101;">
                <span
                  class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"
                  style="left: auto; right: 21.5px;"
                ></span>
                <div class="m-dropdown__inner">
                  <div class="m-dropdown__body">
                    <div class="m-dropdown__content">
                      <ul class="m-nav">
                        <li class="m-nav__section m-nav__section--first m--hide">
                          <span class="m-nav__section-text">Quick Actions</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <!--begin::Portlet-->
          <div class="m-portlet">
            <div class="m-portlet__head">
              <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                  <span class="m-portlet__head-icon m--hide">
                    <i class="la la-gear"></i>
                  </span>
                  <h3 class="m-portlet__head-text">
                    <a
                      :href="'#/expenseCenters'"
                      class="btn btn-sm btn-secondary m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill m--margin-right-10"
                    >
                      <i class="la la-angle-left"></i>
                    </a>
                    Masraf Merkezi Ekle
                  </h3>
                </div>
              </div>
            </div>

            <!--begin::Form-->
            <form class="m-form m-form--fit m-form--label-align-right">
              <div class="m-portlet__body m-form-box-cont">
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Masraf Merkezi Kodu</label>
                    <input type="text"  :class="{ 'is-invalid': $v.expenseCenter.code.$error }" v-model="expenseCenter.code" class="form-control m-input" placeholder="Masraf Merkezi kodunu giriniz." />
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Açıklama</label>
                    <textarea  :class="{ 'is-invalid': $v.expenseCenter.description.$error }" class="form-control m-input" v-model="expenseCenter.description" placeholder="Masraf Merkezi açıklamasını giriniz." id="exampleTextarea" rows="3"></textarea>
                  </div>
                </div>
              </div>
              <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                <div class="m-form__actions m-form__actions--solid">
                  <div class="row">
                    <div class="col-lg-12">
                      <button type="button" @click="expenseCenter.id==0?create():update()" class="spbtn">Kaydet</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <!--end::Form-->
          </div>

          <!--end::Portlet-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import {_create,_getById,_update} from '../../services/ExpenseCenterService'

export default {
created() {
  if(Number(this.$route.params.id)!=0)
        {
          this.expenseCenter.id=Number(this.$route.params.id);
              this.getById();
        }
},

  data() {
    return {
      expenseCenter:{
        id:0,
        code:'',
        description:'',
      }
    }
  },
    validations: {
    expenseCenter: {
      code: { required },
           description: { required }
    }
  },
methods: {
  create:function(){
          this.$v.expenseCenter.$touch();
      if (this.$v.expenseCenter.$error) return;
    _create(this.expenseCenter).then(response=>{
      if(response.data.success)
        this.$router.push({ name: 'expenseCenters' })
    });
  },
  update:function(){
          this.$v.expenseCenter.$touch();
      if (this.$v.expenseCenter.$error) return;
    _update(this.expenseCenter).then(response=>{
      if(response.data.success)
        this.$router.push({ name: 'expenseCenters' })
    });
  },
  getById:function(){
    _getById(Number(this.$route.params.id)).then(response=>{
      if(response.data.success)
      this.expenseCenter=response.data.data;
      else
      this.$router.push({ name: 'expenseCenters' })
    })
  }
},
};
</script>